export enum LayoutType {
    FullPage,
    MultiLayout,
    Agronomy,
    HybridLayout,
}

export function stringIdentifierForLayoutType(layoutType: LayoutType | undefined): string {
  switch(layoutType) {
   case LayoutType.MultiLayout:
    return  'multilayout';
   case LayoutType.Agronomy:
    return  'Agronomy';
   case LayoutType.HybridLayout:
    return  'Hybrid';
   default:
    return  'Catalog';
  }
}



// WEBPACK FOOTER //
// ./src/infrastructure/LayoutTypes.ts